import React from 'react'
import './Spinner.css' // Make sure to create this CSS file

const Spinner = () => {
  return (
    <div className='spinner-container'>
      <div className='loading-spinner'></div>
    </div>
  )
}

export default Spinner
